import { Link } from "react-router-dom";
import { useState } from "react";
import { ShoppingCart, User, Package, X, Menu } from "lucide-react";
import logo_up from "../../assets/images/Logo for website/Desktop.png";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full bg-white/80 backdrop-blur-md shadow-md">
      <div className="w-full max-w-7xl mx-auto flex h-20 items-center justify-between px-4 xl:px-8 relative overflow-x-hidden">
        {/* Mobile View - Centered Logo and Menu Button */}
        <div className="lg:hidden flex items-center justify-between w-full">
          <button
            className="flex items-center gap-2 text-[#333333] hover:text-[#D4AF37] transition-colors duration-200 p-2"
            onClick={() => setIsOpen(true)}
          >
            <Menu className="w-6 h-6" />
          </button>
          <Link to="/" className="absolute left-1/2 transform -translate-x-1/2">
            <img
              src={logo_up}
              className="h-16 w-auto max-h-20 object-contain"
              alt="Logo"
            />
          </Link>
          <div className="w-10"></div> {/* Placeholder for balance */}
        </div>

        {/* Desktop View - Left section - Logo */}
        <div className="hidden lg:flex items-center flex-shrink-0">
          <Link to="/" className="text-xxl font-bold">
            <img
              src={logo_up}
              className="h-12 w-auto max-h-16 object-contain"
              alt="Logo"
            />
          </Link>
        </div>

        {/* Desktop View - Center section - Navigation */}
        <nav className="hidden lg:flex items-center space-x-4 xl:space-x-6 flex-1 justify-center px-4">
          <Link
            to="/"
            className="text-sm xl:text-md font-medium text-[#333333] hover:text-[#D4AF37] transition-colors duration-200 nav-link whitespace-nowrap"
          >
            Home
          </Link>
          <Link
            to="/shop"
            className="text-sm xl:text-md font-medium text-[#333333] hover:text-[#D4AF37] transition-colors duration-200 nav-link whitespace-nowrap"
          >
            Shopping
          </Link>
          <Link
            to="/perfumes"
            className="text-sm xl:text-md font-medium text-[#333333] hover:text-[#D4AF37] transition-colors duration-200 nav-link whitespace-nowrap"
          >
            Perfumes
          </Link>
          <Link
            to="/attars"
            className="text-sm xl:text-md font-medium text-[#333333] hover:text-[#D4AF37] transition-colors duration-200 nav-link whitespace-nowrap"
          >
            Attars
          </Link>
          <Link
            to="/masho-studio"
            className="text-sm xl:text-md font-medium text-[#333333] hover:text-[#D4AF37] transition-colors duration-200 nav-link whitespace-nowrap"
          >
            Masho Studio
          </Link>
          <Link
            to="/new-arrivals"
            className="text-sm xl:text-md font-medium text-[#333333] hover:text-[#D4AF37] transition-colors duration-200 nav-link whitespace-nowrap"
          >
            New Arrivals
          </Link>
          <Link
            to="/combo-gifts"
            className="text-sm xl:text-md font-medium text-[#333333] hover:text-[#D4AF37] transition-colors duration-200 nav-link whitespace-nowrap"
          >
            Gift & Combo
          </Link>
          <Link
            to="/testimonials"
            className="text-sm xl:text-md font-medium text-[#333333] hover:text-[#D4AF37] transition-colors duration-200 nav-link whitespace-nowrap"
          >
            Reviews
          </Link>
          <Link
            to="/about"
            className="text-sm xl:text-md font-medium text-[#333333] hover:text-[#D4AF37] transition-colors duration-200 nav-link whitespace-nowrap"
          >
            About
          </Link>
        </nav>

        {/* Desktop View - Right section - User actions */}
        <div className="hidden lg:flex items-center space-x-4 xl:space-x-6 flex-shrink-0">
          <Link
            to="/cart"
            className="text-[#333333] hover:text-[#D4AF37] transition-colors duration-200"
          >
            <ShoppingCart className="h-6 w-6" />
          </Link>
          <Link
            to="/tracking"
            className="text-[#333333] hover:text-[#D4AF37] transition-colors duration-200"
          >
            <Package className="h-6 w-6" />
          </Link>
          <Link
            to="/profile"
            className="text-[#333333] hover:text-[#D4AF37] transition-colors duration-200"
          >
            <User className="h-6 w-6" />
          </Link>
        </div>

        {/* Mobile View - Dropdown Menu */}
        <div
          className={`fixed top-20 left-0 right-0 bg-gradient-to-b from-[#333333] to-[#1a1a1a] bg-opacity-95 backdrop-blur-md z-50 transition-all duration-300 ease-in-out lg:hidden ${
            isOpen ? "max-h-[calc(100vh-5rem)] opacity-100 overflow-y-auto" : "max-h-0 opacity-0 overflow-hidden"
          }`}
        >
          <nav className="flex flex-col items-start gap-4 p-6">
            <Link
              to="/"
              className="text-lg font-medium text-white hover:text-[#D4AF37] transition-colors duration-200 py-2 w-full nav-link"
              onClick={() => setIsOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/shop"
              className="text-lg font-medium text-white hover:text-[#D4AF37] transition-colors duration-200 py-2 w-full nav-link"
              onClick={() => setIsOpen(false)}
            >
              Shopping
            </Link>
            <Link
              to="/perfumes"
              className="text-lg font-medium text-white hover:text-[#D4AF37] transition-colors duration-200 py-2 w-full nav-link"
              onClick={() => setIsOpen(false)}
            >
              Perfumes
            </Link>
            <Link
              to="/attars"
              className="text-lg font-medium text-white hover:text-[#D4AF37] transition-colors duration-200 py-2 w-full nav-link"
              onClick={() => setIsOpen(false)}
            >
              Attars
            </Link>
            <Link
              to="/masho-studio"
              className="text-lg font-medium text-white hover:text-[#D4AF37] transition-colors duration-200 py-2 w-full nav-link"
              onClick={() => setIsOpen(false)}
            >
              Masho Studio
            </Link>
            <Link
              to="/new-arrivals"
              className="text-lg font-medium text-white hover:text-[#D4AF37] transition-colors duration-200 py-2 w-full nav-link"
              onClick={() => setIsOpen(false)}
            >
              New Arrivals
            </Link>
            <Link
              to="/combo-gifts"
              className="text-lg font-medium text-white hover:text-[#D4AF37] transition-colors duration-200 py-2 w-full nav-link"
              onClick={() => setIsOpen(false)}
            >
              Gift & Combo
            </Link>
            <Link
              to="/testimonials"
              className="text-lg font-medium text-white hover:text-[#D4AF37] transition-colors duration-200 py-2 w-full nav-link"
              onClick={() => setIsOpen(false)}
            >
              Customer Reviews
            </Link>
            <Link
              to="/about"
              className="text-lg font-medium text-white hover:text-[#D4AF37] transition-colors duration-200 py-2 w-full nav-link"
              onClick={() => setIsOpen(false)}
            >
              About
            </Link>
            <div className="w-full border-t border-gray-500 my-4"></div>
            <Link
              to="/profile"
              className="flex items-center gap-3 text-lg font-medium text-white hover:text-[#D4AF37] transition-colors duration-200 py-2 w-full nav-link"
              onClick={() => setIsOpen(false)}
            >
              <User className="h-5 w-5" /> Profile
            </Link>
            <Link
              to="/cart"
              className="flex items-center gap-3 text-lg font-medium text-white hover:text-[#D4AF37] transition-colors duration-200 py-2 w-full nav-link"
              onClick={() => setIsOpen(false)}
            >
              <ShoppingCart className="h-5 w-5" /> Cart
            </Link>
            <Link
              to="/tracking"
              className="flex items-center gap-3 text-lg font-medium text-white hover:text-[#D4AF37] transition-colors duration-200 py-2 w-full nav-link"
              onClick={() => setIsOpen(false)}
            >
              <Package className="h-5 w-5" /> Track Order
            </Link>
          </nav>
        </div>

        {/* Mobile View - Overlay for Background Dimming */}
        {isOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
            onClick={() => setIsOpen(false)}
          ></div>
        )}
      </div>
    </header>
  );
}